import { render, staticRenderFns } from "./PerformanceAuditTable.vue?vue&type=template&id=2049ff56&"
import script from "./PerformanceAuditTable.vue?vue&type=script&lang=ts&"
export * from "./PerformanceAuditTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2049ff56')) {
      api.createRecord('2049ff56', component.options)
    } else {
      api.reload('2049ff56', component.options)
    }
    module.hot.accept("./PerformanceAuditTable.vue?vue&type=template&id=2049ff56&", function () {
      api.rerender('2049ff56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AuditModal/PerformanceAuditTable.vue"
export default component.exports